"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.popoverThemes = exports.TargetContainer = exports.Popover = exports.Arrow = exports.ActionsContainer = exports.ActionSpacer = void 0;
var _taggedTemplateLiteral2 = _interopRequireDefault(require("@babel/runtime/helpers/taggedTemplateLiteral"));
var _styledComponents = _interopRequireWildcard(require("styled-components"));
var _styledIs = _interopRequireDefault(require("styled-is"));
var _framerMotion = require("framer-motion");
var _colors = _interopRequireDefault(require("../../styles/colors"));
var _variables = require("../../styles/variables");
var _mixins = require("../../styles/mixins");
var _HBModal = require("../HBModal/HBModal.styles");
var _templateObject, _templateObject2, _templateObject3, _templateObject4;
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, "default": e }; if (null === e || "object" != _typeof(e) && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t in e) "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]); return f; })(e, t); }
var ARROW_SIZE = 12;
var cssForLeftArrow = (0, _styledComponents.css)(["top:calc(50% - ", "px);box-shadow:-4px 4px 6px ", ";"], ARROW_SIZE / 2, _colors["default"].blue_008);
var cssForRightArrow = (0, _styledComponents.css)(["top:calc(50% - ", "px);box-shadow:4px -4px 6px ", ";"], ARROW_SIZE / 2, _colors["default"].blue_008);
var cssForTopArrow = (0, _styledComponents.css)(["left:calc(50% - ", "px);box-shadow:-4px -4px 6px ", ";"], ARROW_SIZE / 2, _colors["default"].blue_008);
var cssForBottomArrow = (0, _styledComponents.css)(["left:calc(50% - ", "px);box-shadow:4px 4px 6px ", ";"], ARROW_SIZE / 2, _colors["default"].blue_008);
var keepOpenOnHoverBlockStyle = function keepOpenOnHoverBlockStyle(props) {
  return (0, _styledComponents.css)(["width:100%;height:", "px;left:0;"], ARROW_SIZE + props.$offsetY);
};
var keepOpenOnHoverInlineStyle = function keepOpenOnHoverInlineStyle(props) {
  return (0, _styledComponents.css)(["height:100%;width:", "px;top:0;"], ARROW_SIZE + props.$offsetX);
};
var keepOpenOnHoverBlockPosition = function keepOpenOnHoverBlockPosition(props) {
  return "".concat(-ARROW_SIZE - props.$offsetY, "px");
};
var keepOpenOnHoverInlinePosition = function keepOpenOnHoverInlinePosition(props) {
  return "".concat(-ARROW_SIZE - props.$offsetX, "px");
};
var popoverThemes = exports.popoverThemes = {
  popover: {
    background: _colors["default"].white,
    boxShadow: "0 14px 28px 0 ".concat(_colors["default"].blue_015, ", 0 0 10px 0 ").concat(_colors["default"].blue_008),
    minWidth: '50px',
    minHeight: '50px',
    padding: '20px'
  },
  darkTooltip: {
    color: _colors["default"].white,
    background: _colors["default"].neutral900,
    boxShadow: "0 14px 28px 0 ".concat(_colors["default"].black_03),
    padding: '12px',
    cursor: 'auto'
  },
  lightTooltip: {
    color: _colors["default"].neutral900,
    background: _colors["default"].white,
    boxShadow: "0 14px 28px 0 ".concat(_colors["default"].blue_03),
    padding: '12px',
    cursor: 'auto'
  },
  menu: {
    background: _colors["default"].white,
    boxShadow: "0 14px 28px 0 ".concat(_colors["default"].blue_015, ", 0 0 10px 0 ").concat(_colors["default"].blue_008),
    minWidth: '50px',
    minHeight: '50px',
    padding: '8px 0'
  },
  adviceTooltip: {
    background: _colors["default"].blue50,
    boxShadow: "0 14px 28px 0 ".concat(_colors["default"].blue_015, ", 0 0 10px 0 ").concat(_colors["default"].blue_008),
    color: _colors["default"].white,
    padding: '12px 12px 12px 44px',
    cursor: 'auto'
  },
  upgradeTooltip: {
    background: _colors["default"].alpine_01,
    boxShadow: "0 14px 28px 0 ".concat(_colors["default"].blue_015, ", 0 0 10px 0 ").concat(_colors["default"].blue_008),
    color: _colors["default"].neutral900,
    padding: '12px 12px 12px 34px',
    cursor: 'auto'
  },
  calloutNeutral: {
    boxShadow: "0 14px 28px 0 ".concat(_colors["default"].blue_015, ", 0 0 10px 0 ").concat(_colors["default"].blue_008),
    minWidth: '50px',
    minHeight: '50px',
    padding: '20px',
    background: _colors["default"].white
  },
  calloutAccent: {
    boxShadow: "0 14px 28px 0 ".concat(_colors["default"].blue_015, ", 0 0 10px 0 ").concat(_colors["default"].blue_008),
    minWidth: '50px',
    minHeight: '50px',
    padding: '20px',
    background: _colors["default"].purple700
  }
};
function getPopoverTheme(theme) {
  if (!popoverThemes[theme]) {
    return null;
  }
  var _popoverThemes$theme = popoverThemes[theme],
    background = _popoverThemes$theme.background,
    boxShadow = _popoverThemes$theme.boxShadow,
    color = _popoverThemes$theme.color,
    minHeight = _popoverThemes$theme.minHeight,
    minWidth = _popoverThemes$theme.minWidth,
    padding = _popoverThemes$theme.padding,
    cursor = _popoverThemes$theme.cursor;
  return (0, _styledComponents.css)(["background:", ";box-shadow:", ";color:", ";min-height:", ";min-width:", ";padding:", ";cursor:", ";"], background, boxShadow, color, minHeight, minWidth, padding, cursor);
}
function getArrowTheme(theme) {
  var background = popoverThemes[theme].background;
  return (0, _styledComponents.css)(["background:", ";"], background);
}
var Popover = exports.Popover = (0, _styledComponents["default"])(_framerMotion.motion.div).withConfig({
  displayName: "HBPopoverstyles__Popover",
  componentId: "sc-dgei98-0"
})(["position:absolute;border-radius:3px;font-size:14px;max-width:", ";", " z-index:", ";", " pointer-events:none;", " ", " &[data-popper-placement^='top']{&:before{", ";bottom:", ";}> [data-popper-arrow]{bottom:", "px;}}&[data-popper-placement^='top'] > [data-popper-arrow]:after{", "}&[data-popper-placement^='right']{&:before{", ";left:", ";}> [data-popper-arrow]{left:", "px;}}&[data-popper-placement^='right'] > [data-popper-arrow]:after{", "}&[data-popper-placement^='bottom']{&:before{", ";top:", ";}> [data-popper-arrow]{top:", "px;}}&[data-popper-placement^='bottom'] > [data-popper-arrow]:after{", "}&[data-popper-placement^='left']{&:before{", ";right:", ";}> [data-popper-arrow]{right:", "px;}}&[data-popper-placement^='left'] > [data-popper-arrow]:after{", "}&[data-popper-reference-hidden]{visibility:hidden;pointer-events:none;}"], function (props) {
  return props.$maxWidth || '500px';
}, _mixins.proximaNova, _variables.Z_INDEX.POPOVER, function (props) {
  return getPopoverTheme(props.theme);
}, (0, _styledIs["default"])('$isOpen')(_templateObject || (_templateObject = (0, _taggedTemplateLiteral2["default"])(["\n       pointer-events: auto;\n    "]))), (0, _styledIs["default"])('$keepOpenOnHover')(_templateObject2 || (_templateObject2 = (0, _taggedTemplateLiteral2["default"])(["\n        &:before {\n            position: absolute;\n            content: '';\n        }\n    "]))), keepOpenOnHoverBlockStyle, keepOpenOnHoverBlockPosition, ARROW_SIZE / 2, cssForBottomArrow, keepOpenOnHoverInlineStyle, keepOpenOnHoverInlinePosition, -ARROW_SIZE / 2, cssForLeftArrow, keepOpenOnHoverBlockStyle, keepOpenOnHoverBlockPosition, -ARROW_SIZE / 2, cssForTopArrow, keepOpenOnHoverInlineStyle, keepOpenOnHoverInlinePosition, ARROW_SIZE / 2, cssForRightArrow);
var Arrow = exports.Arrow = _styledComponents["default"].div.withConfig({
  displayName: "HBPopoverstyles__Arrow",
  componentId: "sc-dgei98-1"
})(["&:after{content:' ';position:absolute;z-index:1;transform:rotate(45deg);width:", "px;height:", "px;transform-origin:center center;", "}"], ARROW_SIZE, ARROW_SIZE, function (props) {
  return getArrowTheme(props.theme);
});
var TargetContainer = exports.TargetContainer = _styledComponents["default"].div.withConfig({
  displayName: "HBPopoverstyles__TargetContainer",
  componentId: "sc-dgei98-2"
})(["display:inline;", ""], _mixins.focusState);
var ActionsContainer = exports.ActionsContainer = _styledComponents["default"].div.withConfig({
  displayName: "HBPopoverstyles__ActionsContainer",
  componentId: "sc-dgei98-3"
})(["display:flex;gap:8px;", " ", " margin-top:", ""], (0, _styledIs["default"])('$isVertical')(_templateObject3 || (_templateObject3 = (0, _taggedTemplateLiteral2["default"])(["\n        flex-direction: column-reverse;\n        gap: 12px;\n    "]))), function (props) {
  return (0, _HBModal.getAlignment)(props.$actionsAlignment);
}, function (props) {
  return "".concat(props.$marginTop, "px");
});
var ActionSpacer = exports.ActionSpacer = _styledComponents["default"].div.withConfig({
  displayName: "HBPopoverstyles__ActionSpacer",
  componentId: "sc-dgei98-4"
})(["", ""], (0, _styledIs["default"])('$isVertical')(_templateObject4 || (_templateObject4 = (0, _taggedTemplateLiteral2["default"])(["\n        width: 100%;\n    "]))));
//# sourceMappingURL=HBPopover.styles.js.map